import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Popup = ({
  isOpen,
  closePopup,
  popupType,
  handleDelete,
  message,
  deleteLoading,
  setPopupType,
  navigateUrl,
  updateUrl,
  updatemessage,
  proformaData,
  state,
}) => {
  const [deletePopup, setDeletePopup] = useState(false);
  const navigate = useNavigate();

  const popupTypesToShow = [
    "add branch",
    "add category",
    "add quotation",
    "add performa",
    "add invoice",
  ];

  const showPopup = popupTypesToShow.includes(popupType?.type);

  if (!isOpen) return null;

  return (
    <>
      {popupType?.type == "confirm delete" && (
        <>
          <div className="popup-overlay" onClick={closePopup}>
            <div
              className="popup"
              onClick={(e) => e.stopPropagation()}
              style={{
                height: "auto",
              }}
            >
              <div
                style={{ borderBottom: "1px solid #000000" }}
                className="d-flex justify-content-between align-items-center"
              >
                <h6>
                  <b>Alert</b>
                </h6>
                <button
                  onClick={() => {
                    closePopup();
                  }}
                  className="close-btn"
                >
                  X
                </button>
              </div>
              <h5 className="delete-popup-message my-3">{message}</h5>
              <div className="d-flex justify-content-center gap-4 align-items-center">
                <button
                  onClick={() => {
                    handleDelete();
                   
                  }}
                  className="popup_ok_cancel_btn my-2"
                >
                  {deleteLoading ? (
                    <>
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </>
                  ) : (
                    <>YES</>
                  )}
                </button>
                <button
                  onClick={() => {
                    closePopup();
                  }}
                  className="popup_ok_cancel_btn my-2"
                >
                  NO
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {deletePopup && (
        <>
          <div className="popup-overlay" onClick={closePopup}>
            <div
              className="popup"
              onClick={(e) => e.stopPropagation()}
              style={{
                height: "auto",
              }}
            >
              <div
                style={{ borderBottom: "1px solid #000000" }}
                className="d-flex justify-content-between align-items-center"
              >
                <h6>
                  <b>Alert</b>
                </h6>
                <button
                  onClick={() => {
                    closePopup();
                  }}
                  className="close-btn"
                >
                  X
                </button>
              </div>
              <h5 className="delete-popup-message my-3">
                Deleted Successfully
              </h5>
              <div className="d-flex justify-content-center gap-4 align-items-center">
                <button
                  onClick={() => {
                    closePopup();
                    setPopupType({
                      ...popupType,
                      type: "",
                      data: "",
                    });
                    setDeletePopup(false);
                  }}
                  className="popup_ok_cancel_btn my-2"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {popupType?.type == "delete success" && (
        <>
          <div className="popup-overlay" onClick={closePopup}>
            <div
              className="popup"
              onClick={(e) => e.stopPropagation()}
              style={{
                height: "auto",
              }}
            >
              <div
                style={{ borderBottom: "1px solid #000000" }}
                className="d-flex justify-content-between align-items-center"
              >
                <h6>
                  <b>Alert</b>
                </h6>
                <button
                  onClick={() => {
                    closePopup();
                  }}
                  className="close-btn"
                >
                  X
                </button>
              </div>
              <h5 className="delete-popup-message my-3">
                Deleted Successfully
              </h5>
              <div className="d-flex justify-content-center gap-4 align-items-center">
                <button
                  onClick={() => {
                    closePopup();
                    setPopupType({
                      ...popupType,
                      type: "",
                      data: "",
                    });
                    setDeletePopup(false);
                  }}
                  className="popup_ok_cancel_btn my-2"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ borderBottom: "1px solid #000000" }}
            >
              <h6>
                <b>Alert</b>
              </h6>
              <button onClick={closePopup} className="close-btn">
                X
              </button>
            </div>
            <h5 className="delete-popup-message my-3">
              {state ? updatemessage : message}
            </h5>
            <div className="d-flex justify-content-center gap-4 align-items-center">
              <button
                onClick={() => {
                  if (proformaData) {
                    navigate(navigateUrl, { state: proformaData });
                  } else {
                    navigate(navigateUrl);
                  }
                }}
                className="popup_ok_cancel_btn my-2"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
